module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-03.f136574e.png";